/** Abstract Pacific Northwest Coast formline-inspired watermark.
 *  Kept extremely low-opacity and abstract out of cultural respect. */
export const Formline = ({ className = "", opacity = 0.05 }) => (
  <svg
    viewBox="0 0 400 400"
    className={className}
    style={{ opacity }}
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M200 40c70 0 120 55 120 130 0 60-40 95-40 130 0 25 20 40 20 60H100c0-20 20-35 20-60 0-35-40-70-40-130C80 95 130 40 200 40Z"
      stroke="#dc2626"
      strokeWidth="6"
    />
    <path
      d="M140 150c25-18 55-18 60 8 4 20-18 30-38 24-22-7-30-24-22-32Z"
      fill="#dc2626"
    />
    <path
      d="M260 150c-25-18-55-18-60 8-4 20 18 30 38 24 22-7 30-24 22-32Z"
      fill="#dc2626"
    />
    <path
      d="M170 250c15 22 45 22 60 0"
      stroke="#dc2626"
      strokeWidth="6"
      strokeLinecap="round"
    />
    <circle cx="150" cy="152" r="7" fill="#050505" />
    <circle cx="250" cy="152" r="7" fill="#050505" />
  </svg>
);
